import React, { useEffect } from "react";
import { urlAPI, getUser, getToken } from "utility/Common";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import { Card, CardBody, Alert } from "reactstrap";
import * as Icons from "react-feather";
import "assets/scss/pages/dashboard-analytics.scss";
import { useHistory } from "react-router-dom";
import decorLeft from "assets/img/elements/decore-left.png";
import decorRight from "assets/img/elements/decore-right.png";

export default function Index(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const checkToken = () => {
    Axios.get(urlAPI + "/v1/checktoken", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        checkUserInfo();
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
        }
      });
  };

  const checkUserInfo = () => {
    if (getUser()?.role_dof === "DIREKSI") {
      // history.push("/user");
      // history.push("/");
    }

    if (getUser()?.sbu === null || getUser()?.sbu?.trim() === "") {
      dispatch({
        type: "FILL_INFO",
        info: true,
        pesan:
          "Akun anda belum terdaftar di SBU manapun, hal tersebut akan mempengaruhi jalannya SIRS. Mohon Hubungi Administrator.",
      });
    }
    if (getUser()?.unit === null || getUser()?.unit?.trim() === "") {
      dispatch({
        type: "FILL_INFO",
        info: true,
        pesan:
          "Akun anda belum terdaftar di Unit manapun, hal tersebut akan mempengaruhi jalannya SIRS. Mohon Hubungi Administrator.",
      });
    }
    if (
      getUser()?.unitpenerima === null ||
      getUser()?.unitpenerima?.trim() === ""
    ) {
      dispatch({
        type: "FILL_INFO",
        info: true,
        pesan:
          "Akun anda belum terdaftar di Unit Penerima manapun, hal tersebut akan mempengaruhi jalannya SIRS. Mohon Hubungi Administrator.",
      });
    }
    // console.log("getUser()?.nik", getUser());
    if (getUser()?.nik == null || getUser()?.nik?.trim() == "") {
      if (getUser()?.role_dof !== "DOKTER") {
        dispatch({
          type: "FILL_INFO",
          info: true,
          pesan:
            "Akun Anda Belum Dilengkapi NIK KARYAWAN, Mohon Untuk Segera Dilengkapi.",
        });
        // history.push("/account/ubah_password");
      }
    } else {
      dispatch({
        type: "FILL_INFO",
        info: false,
        pesan: "",
      });
    }
  };

  useEffect(() => {
    if (getToken()){
      checkToken();
    }
  }, []);

  return (
    <>
      <Alert color="warning">
        <h4 className="alert-heading" style={{ color: "black" }}>
          Informasi
        </h4>
        <div className="alert-body">
          <p style={{ color: "black" }}>
            Mohon Gunakan Browser <strong>Google Chrome</strong> dan pastikan
            telah menggunakan versi terbaru untuk mendapatkan pengalaman terbaik
            dalam menggunakan <strong>SIRS</strong>
          </p>
        </div>
      </Alert>
    </>
  );
}
